<h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level" style="margin-bottom: 0px">
  <ng-container [ngSwitch]="customer.isCompany">
    <span *ngSwitchCase="false"
          i18n='Customer section title@@customerOverviewComponent.sectionHeading.customerData'
          class="esf-action-heading__text">Customer data</span>
    <span *ngSwitchCase="true"
          i18n='Customer section title@@customerOverviewComponent.sectionHeading.companyData'
          class="esf-action-heading__text">Company data</span>
  </ng-container>
  <span class="esf-action-heading__actions">
    <span class="esf-action-heading__action">
      <button class="esf-button esf-button--simple" (click)="editCustomer()" [edsTooltip]="tooltipTranslations.i18nEdit">
        <svg class="esf-icon esf-button__icon" width="16" height="16">
          <use xlink:href="#esf-icon-edit"></use>
        </svg>
        <span class="esf-button__icon-text"></span>
      </button>
    </span>
  </span>
</h4>
<div class="esf-info-tile customer-overview-box-width" style="flex: 1;">
  <div class="esf-info-tile__content">
    <div class="esf-grid esf-grid--gutter-y-xxs esf-grid--x-between esf-grid--center-y">
      <div class="esf-grid__item">
        <div class="esf-icon-and-text esf-icon-and-text--xs">
          <svg class="esf-icon" width="16" height="16" [edsTooltip]="tooltipTranslations.i18nCustomerNumber">
            <use xlink:href="#esf-icon-user-number"></use>
          </svg>
          <div class="esf-icon-and-text__text externalNumber">{{ customer.externalNumber || '/' }}</div>
        </div>
      </div>
      <div class="esf-grid__item">
        <a class="esf-tag" [edsTooltip]="customer.state.translatedLockingReason" [ngClass]="customer.state.status.class">{{ customer.state.status.status }}</a>
      </div>
    </div>
    <ng-container *ngIf="currentMembership && (selectedClub?.isCrmMembershipActive || selectedClub?.isCampaiMembershipActive)">
      <div class="esf-grid esf-grid--gutter-y-xxs esf-grid--x-between esf-grid--center-y">
        <div class="esf-grid__item">
          <div class="esf-icon-and-text esf-icon-and-text--xs">
            <svg class="esf-icon" width="16" height="16" [edsTooltip]="tooltipTranslations.i18nMembershipNumber">
              <use xlink:href="#esf-icon-membership-number"></use>
            </svg>
            <span class="esf-icon-and-text__text membershipNumber">{{ currentMembership.membershipNumber || '/' }}</span>
          </div>
        </div>
        <div class="esf-grid__item">
          <!-- <a class="esf-tag" [ngClass]="{ 'esf-tag--success': customer.membership.status === 'member',
          'esf-tag--alert': customer.membership.status === 'terminated' || customer.membership.status === 'locked'}"
          *ngIf="customer?.membership && membershipListComponent">{{ membershipListComponent?.getTranslatedMembershipStatus(customer.membership) || '' }}</a> -->
        </div>
      </div>
    </ng-container>
    <p>
      <small>
        <ng-container [ngSwitch]="customer.isCompany">
          <ng-container *ngSwitchCase="false">
            <span class="name-prefix">{{ customer.salutation.getTranslatedSalutation || '' }} </span>
            <span class="title">{{ customer.title || '' }} </span>
            <span class="firstName">{{ customer.firstName || '' }} </span><span class="lastName">{{ customer.lastName || '' }}</span><br>
            <span class="company" *ngIf="customer.company">{{ customer.company }}<br></span>
          </ng-container>

          <ng-container *ngSwitchCase="true">
            <span class="company" *ngIf="customer.company">{{ customer.company }}</span><br>
            <span class="name-prefix">{{ customer.salutation.getTranslatedSalutation || '' }} </span>
            <span class="title">{{ customer.title || '' }} </span>
            <span class="firstName">{{ customer.firstName || '' }} </span><span class="lastName">{{ customer.lastName || '' }}</span><br>
          </ng-container>
        </ng-container>

        <span class="birthday" *ngIf="customer.birthday">
          {{ customer.birthday.date | date:customer.birthday.format || '' }} - {{ getAge(customer.birthday.date) }}
          <span i18n="After age number text@@customerOverviewComponent.text.yearsOld">years old</span>
        </span>

      </small>
    </p>
  </div>
</div>
